module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAKElEQVQ4T2NgGBxgXsJ/svAwMuDPRbH/5OBBZIBV6ZH/5ODhZMDQBgASUnFsZaeuGwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/GA.png
// module id = 1142
// module chunks = 0